const React = require('react');
const noop = require('mn-utils/noop');
const Ripple = require('../../../../Ripple');
const {Link} = require("../../../../../../router");

module.exports = ({link, onClick = noop}) => {
  const component = link ? Link : undefined;
  const href = link || undefined;

  return (
    <Ripple
      component={component}
      className="(dn)>svg (x-1):h>svg"
      href={href}
      onClick={onClick}
    >
      <svg width="38" height="12" viewBox="0 0 38 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="5" width="36" height="2" fill="#2C2D30"/>
        <path d="M8 1.5L6.3696 -1.42534e-07L4.29138e-07 6L6.3696 12L8 10.5L3.2 6L8 1.5Z" fill="#2C2D30"/>
      </svg>
    </Ripple>
  )
}
